export default __webpack_public_path__ + "static/media/Chevron_Right_MD.5ba1f147.svg";